import EmbedScriptEvent from './event/EmbedScriptEvent';

const ELEMENT_MIN_HEIGHT = 80;

const DEFAULT_STYLES =
	'position: fixed;' +
	'width: 56px;' +
	'height: 56px;' +
	'border-radius: 28px;' +
	'right: 17px;' +
	'bottom: 13px;' +
	'cursor: pointer;' +
	'border: none;' +
	'justify-content: center;' +
	'align-items: center;';

export class AddCommentButton {
	constructor(parentDiscussionInstance, addTextareaMock) {
		this._parentDiscussionInstance = parentDiscussionInstance;
		this.addTextareaMock = addTextareaMock;

		this.visible = null;
	}

	render(styles, visibilityData) {
		if (this.element) {
			return this.element;
		}

		this.element = document.createElement('button');

		if (this.addTextareaMock) {
			/* Invisible textarea to obtain focus on click and open keyboard on mobile.
			 * Actual comment input is in widget.
			 */
			this._textarea = document.createElement('textarea');
			this._textarea.style =
				'position: absolute; top: -1000px; left: -3000px; opacity: 0, font-size: 16px;';

			this.element.appendChild(this._textarea);
		}

		this._parentDiscussionInstance._wrapper.appendChild(this.element);
		this._renderPlusSvg(this.element, `rgba(${styles.color}`);

		this.element.style =
			DEFAULT_STYLES + `background-color: rgba(${styles.backGroundColor});`;

		this.element.addEventListener('click', () => {
			const originalViewPortContent = document
				.querySelector('meta[name=viewport]')
				.getAttribute('content');
			document
				.querySelector('meta[name=viewport]')
				.setAttribute(
					'content',
					'width=device-width, initial-scale=1.0, maximum-scale=1.0'
				);

			this._parentDiscussionInstance.sendEvent(
				EmbedScriptEvent.ADD_COMMENT_BUTTON_CLICKED
			);
			this._textarea && this._textarea.focus();

			// TODO viewport meta should be restored after widget init not 5s.
			setTimeout(() => {
				document
					.querySelector('meta[name=viewport]')
					.setAttribute('content', originalViewPortContent);
			}, 5000);
		});

		this.checkVisibility(visibilityData.window, visibilityData.iframe);

		return this.element;
	}

	// consider replace this with Intersection Observer
	checkVisibility(window, iframe) {
		if (!this.element) {
			return;
		}

		const viewportHeight = window.height;
		const isViewPortUnderIframeTop =
			iframe.top - viewportHeight + ELEMENT_MIN_HEIGHT < 0;
		const isViewPortAboveIframeBottom = iframe.bottom - ELEMENT_MIN_HEIGHT > 0;

		if (isViewPortUnderIframeTop && isViewPortAboveIframeBottom) {
			this.show();
		} else {
			this.hide();
		}
	}

	destroy() {
		if (this.element) {
			this.element.remove();
			this.element = null;
			this.visible = null;
		}
	}

	show() {
		if (this.visible === true) {
			return;
		}

		this.element.style.display = 'flex';
		this.visible = true;
	}

	hide() {
		if (this.visible === false) {
			return;
		}

		this.element.style.display = 'none';
		this.visible = false;
	}

	_renderPlusSvg(root, fill) {
		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.setAttribute('width', '32px');
		svg.setAttribute('height', '32px');
		svg.setAttribute('viewbox', '0 0 32 32');
		svg.setAttribute('fill', 'none');

		const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		path.setAttribute('fill', fill);
		path.setAttribute(
			'd',
			'M22.6667 14.6667H17.3333V9.33333C17.3333 8.596 16.736 8 16 8C15.264 8 14.6667 8.596 14.6667 9.33333V14.6667H9.33333C8.59733 14.6667 8 15.2627 8 16C8 16.7373 8.59733 17.3333 9.33333 17.3333H14.6667V22.6667C14.6667 23.404 15.264 24 16 24C16.736 24 17.3333 23.404 17.3333 22.6667V17.3333H22.6667C23.4027 17.3333 24 16.7373 24 16C24 15.2627 23.4027 14.6667 22.6667 14.6667Z'
		);

		svg.appendChild(path);
		root.appendChild(svg);
	}
}
